const RouteShippingStageEnum = {
  ENTREGUE: {
    value: "DELIVERED",
    label: "Entregues com sucesso",
  },
  PENDENTE: {
    value: "PENDING",
    label: "Pendentes",
  },
  NAO_ENTREGUE: {
    value: "UNDELIVERED",
    label: "Não entregues",
  },
};

export { RouteShippingStageEnum }
